import styled from "@emotion/styled";
// import media from "../../breakpoints";

const TeamSectionWrapper = styled.section``;

export { TeamSectionWrapper };
